export default {
  items: [
    {
      subheader: 'Inventario',
      items: [
        {
          title: 'Bowl',
          icon: 'Archive',
          href: '/app/bowl/list',
          items: [
            {
              title: 'Tipologie Bowl',
              href: '/app/bowltype/list'
            }
          ]
        }
      ]
    },
    {
      subheader: 'Transazioni',
      items: [
        {
          title: 'Prestiti e Restituzioni',
          icon: 'Refresh',
          href: '/app/bowl/list',
          items: [
            {
              title: 'Elenco transazioni',
              href: '/app/bowltransaction/list'
            }
          ]
        }
      ]
    },
    {
      subheader: 'E-Commerce',
      items: [
        {
          title: 'Prodotti',
          icon: 'Cart',
          href: '/app/product/list',
          items: [
            {
              title: 'Elenco prodotti',
              href: '/app/product/list'
            }
          ]
        },
        {
          title: 'Offerte',
          icon: 'Tag',
          href: '/app/offer/list',
          items: [
            {
              title: 'Elenco offerte',
              href: '/app/offer/list'
            }
          ]
        }
      ]
    },
    {
      subheader: 'Account',
      items: [
        {
          title: 'Business',
          icon: 'StorefrontOutlined',
          href: '/app/business/list'
        },
        {
          title: 'Clienti',
          icon: 'Users',
          href: '/app/customer/list'
        }
      ]
    }
  ]
};
